import { Navigate, Route, Routes } from 'react-router'
import { ChatbotRoutes } from 'entities/ExportRouters'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ChatbotPath } from 'pages/chatbot/route/chatbotPath'
import { Configure } from 'pages/chatbot/ui/UnifiedAgent/ui/Configure/Configure'
import { ChatbotNewPage } from 'pages/chatbot/pages/chatbotNew/ui/ChatbotNewPage'
import { ChatbotNewV2Layout } from 'pages/chatbot/pages/chatbotNew/layout/ChatbotNewV2Layout'
import { Chat } from 'pages/chatbot/ui/UnifiedAgent/ui/Chat/Chat'

export const ChatbotNewRouter = () => {
  const { featureFlagsStore } = useEntitiesContext()

  if (!featureFlagsStore.unified_agent_enabled) {
    return (
      <Routes>
        <Route index element={<ChatbotNewPage />} />
        <Route path='*' element={<Navigate to={`/${ChatbotPath.new}`} replace />} />
      </Routes>
    )
  }

  return (
    <Routes>
      <Route element={<ChatbotNewV2Layout />}>
        <Route index element={<Navigate to={ChatbotRoutes.chat} replace />} />
        <Route path={ChatbotRoutes.chat} element={<Chat />} />
        <Route path={ChatbotRoutes.config} element={<Configure />} />
      </Route>
      <Route path='*' element={<Navigate to={ChatbotPath.newChat} replace />} />
    </Routes>
  )
}
